import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';
import { GlobalService } from '../../services/global.service';

@Component({
    selector: 'app-parameter-field',
    templateUrl: './parameter-field.component.html',
    styleUrls: ['./parameter-field.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: ParameterFieldComponent
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: ParameterFieldComponent
        }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ParameterFieldComponent implements ControlValueAccessor, Validator {

  @Input() fullWidth;
  @Input() title;
  @Input() statusColor;
  @Input() disabled = false;
  @Input() type;
  @Input() total;
  @Input() auxValue;
  @Input() selectList = [];
  
  @Output() openSpecialModal = new EventEmitter();
  @Output('onChange') onChangeForm = new EventEmitter();
  
  
  validValue;
  value;
  touched = false;

  onChange = (value) => {}
  onTouched = () => {}


  constructor(private _gS: GlobalService) { }
  validate(control: AbstractControl): ValidationErrors | null{
    const value = control.value
    if(value > 0){
      return {
        mustBePositive: {value}
      }
    }
  }
  
  writeValue(value: any): void {
    this.value = value
    this.validValue = this.getValue(value)
  }
  
  registerOnChange(fn: any): void {
    this.onChange = fn
  }
  
  registerOnTouched(fn: any): void {
    this.onTouched = fn
  }
  
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled
  }

  changeValue(event){
    const value = event.target.value
    this.onChange(value)
    this.validValue = this.getValue(value)

    this.onChangeForm.emit(value)
  }

  getValue(ev) {
    ev = isFinite(ev) ? (ev || 0) : 0 

		if (this.type == 'number' || this.type == 'popup' || this.type == 'currency') {
			let val = Math.floor(parseFloat(this.value));
			return val || 0;
		} else if (this.type == 'minutes') {
			var min = Math.floor(parseFloat(this.value));
			return min || 0
    } else if (this.type == 'pages') {
      var intPage = this.getPagesInt(ev);
      return intPage || 0
    }
		return ev
	}

  getSegValue(ev) {
		var min = Math.floor(parseFloat(this.value))
		var sec = Math.round((parseFloat(this.value) - min) * 60)

		if (sec < 10) {
			return ':0' + sec
		} else {
			return ':' + sec
		}
	}
	getRoofValue(ev) {
		return this.value ? Math.floor(parseFloat(this.value)) : 0
	}
	get1000Value(ev) {
		var a = Math.round((parseFloat(this.value) % 1)  * 100)
		return a
	}

  getPagesInt(ev){
    if(!ev) return 0
    const pages = this._gS.getPages(ev).split(' ')
    return pages.length > 0 ? pages[0] : 0
  }

  getPagesFraction(ev){
    if(!ev) return 0
    const pages = this._gS.getPages(ev).split(' ')
    return pages.length > 0 ? pages[1] : 0
  }

  openPopUp(){
    this.openSpecialModal.emit()
  }

  
  
  ngOnInit(): void {
    this.validValue = this.getValue(this.value)
  }

}
